import { useTheme } from "next-themes"

import { selectEmbedded } from "@/lib/storage/app-slice"
import { useAppSelector } from "@/lib/storage/hooks"

export type EffectiveTheme = "light" | "dark"

export function useEffectiveTheme(): EffectiveTheme {
  const { resolvedTheme } = useTheme()
  const embedded = useAppSelector(selectEmbedded)

  if (embedded) {
    return "light"
  }

  return resolvedTheme === "dark" ? "dark" : "light"
}
